<template>
  <highcharts :constructor-type="'mapChart'" :options="mapOptions" class="map"></highcharts>
</template>

<script>
export default {
  props: {
    primary: Boolean,

    title: String,

    mapD: Array,
  },

  data() {
    console.log("map data", this.mapD)
    return {
      mapOptions: {
        chart: {
          map: "myMapName"
        },
        title: {
          text: this.title
        },
        legend: {
          enabled: false
        },
        // legend: {
        //     layout: 'horizontal',
        //     borderWidth: 0,
        //     backgroundColor: 'rgba(255,255,255,0.85)',
        //     floating: true,
        //     verticalAlign: 'top',
        //     y: 5
        // },
        // mapNavigation: {
        //     enabled: true
        // },

        colorAxis: {
            min: 1,
            type: 'logarithmic',
            // minColor: '#EEEEFF',
            // maxColor: '#000022',
            minColor: '#AAD4F2',
            maxColor: '#00AAFF',
            stops: [
                [0, '#AAD4F2'],
                // [0, '#EFEFFF'],
                // [0.67, '#4444FF'],
                [1, '#00AAFF']
                // [1, '#000022']
            ]
        },
        series: [
          {
            name: this.title,
            states: {
              // hover: {
              //   color: "#BADA55"
              // }
            },
            dataLabels: {
              enabled: true,
              color: '#FFFFFF',
              format: "{point.name}"
            },
            // animation: {
            //     duration: 1000
            // },
            data: this.mapD
          }
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                'printChart',
                'separator',
                'downloadPNG',
                'downloadJPEG',
                'downloadPDF',
                'downloadSVG',
                'separator',
                'downloadCSV',
                'downloadXLS',
                'viewData'

              ]
            }
          }
        }
      }
    };
  }
};
</script>
 <style scoped>
.map {
  min-height: 500px;
}
</style>
